export default __webpack_public_path__ + "static/media/remainders.8ffb4e0d.svg";